﻿import "regenerator-runtime/runtime";
import React, { useState, Fragment, useCallback, useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
import moment from "moment";
import { ShopWindow } from "./Interfaces";

export function ShopCountdown(props: { current?: ShopWindow, next?: ShopWindow, refresh: () => void }) {
    const [now, setNow] = useState(new Date());
    const dates = useMemo(() => {
        return {
            currentOpens: props.current?.opens ? new Date(props.current.opens) : null,
            currentCloses: props.current?.closes ? new Date(props.current.closes) : null,
            currentMarket: props.current?.market ? new Date(props.current.market) : null,
            nextOpens: props.next?.opens ? new Date(props.next.opens) : null,
            nextCloses: props.next?.closes ? new Date(props.next.closes) : null,
            nextMarket: props.next?.market ? new Date(props.next.market) : null,
        }
    }, [props.current, props.next]);

    let status = 'terminal';
    if (dates.nextOpens && (!dates.currentCloses || dates.currentCloses < now)) {
        status = 'closed';
    }
    else if (dates.currentCloses > now) {
        status = 'open';
    }

    useEffect(() => {
        if (status === 'terminal')
            return;

        props.refresh();

        const interval = setInterval(() => {
            setNow(new Date());
        }, 1000);

        return () => clearInterval(interval);
    }, [status]);

    /*
     *  The shop is currently open until x date, market day will be x date.
        The shop is currently closed until x date, it will then close on x date and the next market day will be x date
     */ 

    if (status === 'terminal') {
        return (<div className="alert alert-warning mb-0 flex-grow-1" role="alert">
            The shop is currently closed. An opening date has not yet been set, so check back later.
        </div>)
    }    

    if (status === 'open') {
        const closing = moment(dates.currentCloses);
        const marketDay = moment(dates.currentMarket);

        const tillClosing = moment.duration(closing.diff(moment()));

        if (tillClosing.asHours() < 16) {
            return (<div className="alert alert-warning mb-0 flex-grow-1" role="alert">
                {`The shop is closing in ${tillClosing.humanize()}. Place your order soon! Market day will be ${marketDay.format('dddd, MMMM Do YYYY')}.`}
            </div>);
        }
        else {
            return (<div className="alert alert-secondary mb-0 flex-grow-1" role="alert">
                {`The shop is currently open until ${closing.format('dddd, MMMM Do YYYY [at] hA')}. Market day will be ${marketDay.format('dddd, MMMM Do YYYY')}.`}
            </div>);
        }
    }

    if (status === 'closed') {
        const opening = moment(dates.nextOpens);
        const closing = moment(dates.nextCloses);
        const marketDay = moment(dates.nextMarket);

        return (<div className="alert alert-warning mb-0 flex-grow-1" role="alert">
            {`The shop is currently closed. It will be opening at ${opening.format('dddd, MMMM Do YYYY [at] hA')}. It will then close at ${closing.format('dddd, MMMM Do YYYY [at] hA')} and the next market day will be on ${marketDay.format('dddd, MMMM Do YYYY')}.`}            
        </div>);
    }

    return null;
}